export enum DocumentTypeName {
  Passport = 'Passport',
  Visa = 'Visa'
}
